import { useQuery } from '@tanstack/react-query'
import { NavigationQueryKeys } from '../navigation.query-keys'

export function useNavigationMenu() {
  return useQuery({ refetchOnMount: false, ...NavigationQueryKeys.menu })
}
